import React from "react";
import { useRouteData } from "../../router/RouteDataProvider";
import { useParams } from "../../router/Router";
import Tournament from "../Tournament";
import TournamentsByDateFetcher from "./TournamentsByDateFetcher";
import NotFound from "../../common/NotFound";

export default function Sport() {
    const routeData = useRouteData();
    const params = useParams();

    try {
        const s = routeData.tournamentsData.sportById.get(params.sportId);
    
        return (
            <>
                <div className="c_42">
                    <div className="c_42_1">
                        <span className="c_42_1_1"></span>
                        <span className="c_42_1_2">{s.descrizione}</span>
                        {/* <Img className="c_42_1_3" src="icon_chevron.svg" height="16px" width="16px" data-rotate="270" /> */}
                    </div>
                    {/* <Img className="c_42_2" src="Favs_default.svg" height="16px" width="16px" /> */}
                </div>
                {/* <RenderOnScroll> */}
                    <TournamentsByDateFetcher date={routeData.date} sportId={s.id} aggId={s.aggregata} renderItem={(data) =>
                        <>
                            {data.tournaments.map(t =>
                                <Tournament key={t.id} data={t} />
                            )}
                        </>
                    } />
                {/* </RenderOnScroll> */}
            </>
        );
    } catch(e) {
        return <NotFound />
    }
}
